import React, { Component } from 'react';
import { Link } from 'react-router';

import Prismic from 'prismic-javascript';
import { PrismicConfig } from '../helpers/prismicHelpers/PrismicAPI';
import { LanguagePrismicHelper } from '../helpers/prismicHelpers/PrismicHelpers';
import { layoutHelperDynamicURLs } from '../helpers/LayoutHelpers';
import Loader from '../components/common/elements/Loader';
import uuid from '../helpers/uuid';
import Logo from '../components/dashboardNew/objects/Logo';
import Anchor from "../components/dashboardNew/objects/Anchor";

class Footer extends Component {
	constructor(props) {
		super(props);
		this.state = {
			footerDetails: '',
		};
	}

	async componentWillMount() {
		const languagePrismic = LanguagePrismicHelper();

		try {
			const res = await Prismic.api(PrismicConfig.apiEndpoint, {
				apiAccessToken: PrismicConfig.apiAccessToken,
			});

			const json = await res.query(
				Prismic.Predicates.at('document.type', 'footer'),
				languagePrismic
			);

			let formatData = {
				...layoutHelperDynamicURLs(json),
			};

			this.setState({ footerDetails: formatData.footer });
		} catch (err) {
			return { error: true };
		}
	}

	showCurrentYear() {
		return new Date().getFullYear();
	}

	showAddress() {
		const { pathname } = this.props;
		if (
			pathname.includes('/login') ||
			pathname.includes('/reset-password') ||
			(!localStorage.token &&
				(pathname.includes('privacy') ||
					pathname.includes('cookies') ||
					pathname.includes('terms')))
		)
			return false;
		return true;
	}

	render() {
		const { footerDetails } = this.state;
		if (!footerDetails) return <Loader />;

		return (
			<footer className="main-footer" id="footer">
				<div className="container">
					<div className="row">
						<div className="col-12 col-md-4 footer-content">
							<Logo
								logo={'logoLight'}
								altText={'In Touch Networks logo'}
								logoClass={'logo-image'}
								path={'/'}
							/>
							{this.showAddress() && (
								<div className="footer-adderss">
									{footerDetails &&
									footerDetails.address.map(line => {
										return <p className="body-copy" key={uuid()}>{line.text}</p>;
									})}
								</div>
							)}
						</div>
						<div className="col-12 col-md-8 footer-content links">
							<ul className="footer-links-list">
								{footerDetails &&
									footerDetails.links.map(policy_link => {
									return (
										<li key={uuid()} className="footer-links-item">
											<Anchor path={`/legal${policy_link.url}`} anchorClass="footer-links-link" internal>
												{' '}
												{policy_link.title}
											</Anchor>{' '}
											<span className="item-break">|</span>
										</li>
									);
								})}
							</ul>
							<p className="body-copy">{` Copyright ${this.showCurrentYear()} In Touch Networks. All rights reserved.`}</p>
						</div>
					</div>
				</div>
			</footer>
		);
	}
}

export default Footer;



// WEBPACK FOOTER //
// src/client/layouts/Footer.js